"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AcknowledgeMessage_1 = __importDefault(require("./AcknowledgeMessage"));
const HelloMessage_1 = __importDefault(require("./HelloMessage"));
const encode_1 = require("../ua/encode");
const ConnectionProtocolMessageHeader_1 = __importDefault(require("./ConnectionProtocolMessageHeader"));
// import OpenSecureChannelResponse from '../ua/OpenSecureChannelResponse'
// import { Decode } from '../ua/decode'
const KB = 1024;
const MB = 1024 * KB;
const DefaultMaxMessageSize = 2 * MB;
const DefaultReceiveBufferSize = 0xffff;
const DefaultSendBufferSize = 0xffff;
const DefaultMaxChunkCount = 512;
class Connection extends EventTarget {
    constructor(options) {
        super();
        this.onerror = (event) => {
            console.log('onerror', event);
        };
        this.onmessage = (event) => {
            const header = new ConnectionProtocolMessageHeader_1.default();
            const offset = header.decode(event.data);
            switch (header.MessageType) {
                case 'ACK': {
                    const acknowledge = new AcknowledgeMessage_1.default();
                    acknowledge.decode(event.data, offset);
                    if (acknowledge.ProtocolVersion !== 0) {
                        throw new Error('invalid version');
                    }
                    if (acknowledge.MaxChunkCount === 0) {
                        acknowledge.MaxChunkCount = DefaultMaxChunkCount;
                    }
                    if (acknowledge.MaxMessageSize === 0) {
                        acknowledge.MaxMessageSize = DefaultMaxMessageSize;
                    }
                    this.acknowledge = acknowledge;
                    this.dispatchEvent(new Event('ack'));
                    break;
                }
                default:
                    break;
            }
        };
        this.onopen = () => {
            const hello = new HelloMessage_1.default({
                ProtocolVersion: this.acknowledge.ProtocolVersion,
                ReceiveBufferSize: this.acknowledge.ReceiveBufferSize,
                SendBufferSize: this.acknowledge.SendBufferSize,
                MaxMessageSize: this.acknowledge.MaxMessageSize,
                MaxChunkCount: this.acknowledge.MaxChunkCount,
                EndpointUrl: 'foo'
            });
            this.send('HEL', 'F', hello);
        };
        this.send = (MessageType, ChunkType, message) => {
            const body = encode_1.encode({ instance: message });
            // 8 bytes for header length
            const header = new ConnectionProtocolMessageHeader_1.default({
                MessageType,
                ChunkType,
                MessageSize: body.byteLength + 8
            }).encode();
            const b = new Uint8Array(header.byteLength + body.byteLength);
            b.set(new Uint8Array(header));
            b.set(new Uint8Array(body), header.byteLength);
            this.socket.send(b);
        };
        this.socket = new WebSocket(options.endpoint);
        this.socket.binaryType = 'arraybuffer';
        this.acknowledge = new AcknowledgeMessage_1.default({
            ReceiveBufferSize: DefaultReceiveBufferSize,
            SendBufferSize: DefaultSendBufferSize,
            MaxChunkCount: 0,
            MaxMessageSize: 0
        });
        this.socket.addEventListener('message', this.onmessage);
        this.socket.addEventListener('open', this.onopen);
        this.socket.addEventListener('error', this.onerror);
    }
}
exports.default = Connection;
